/**
 * Egy path-t darabokra szedünk.
 * @param path - A megadott path.
 */
export default function getPartsFromPath (path: string): string[] {
  const [
    ,        // Az első darab nem kell, mert az üres.
    ...parts // Ezek a darabkák.
  ] = path.split('/')

  return parts
}
